// Human label for a Graph presence value, in the guide's language.

import type { TFn } from '../context';
import type { PresenceInfo } from './callFlowStatus';

export function presenceLabel(t: TFn, info?: PresenceInfo): string {
  const a = String(info?.availability || '').toLowerCase();
  if (!a || a === 'presenceunknown') return t('presenceUnknown');
  if (a.startsWith('available')) return t('presenceAvailable');
  if (a === 'inacall') return t('presenceInCall');
  if (a === 'inameeting' || a === 'presenting') return t('presenceInMeeting');
  if (a === 'donotdisturb' || a === 'focusing') return t('presenceDnd');
  if (a.startsWith('busy')) return t('presenceBusy');
  if (a === 'away' || a === 'berightback') return t('presenceAway');
  if (a === 'offline' || a === 'outofoffice') return t('presenceOffline');
  return info?.availability || t('presenceUnknown');
}

